import { cn } from 'ui'
import { usePDFStore } from '../../stores/pdf.store'

export const PageContainer = ({
  children,
  style,
  className,
}: {
  children: React.ReactNode
  style?: React.CSSProperties
  className?: string
}) => {
  return (
    <div style={style} className={cn('py-10 px-1 space-y-10', className)}>
      {children}
    </div>
  )
}
